import { render, staticRenderFns } from "./volunteerD.vue?vue&type=template&id=6b8edec3&scoped=true&"
import script from "./volunteerD.vue?vue&type=script&lang=js&"
export * from "./volunteerD.vue?vue&type=script&lang=js&"
import style0 from "./volunteerD.vue?vue&type=style&index=0&id=6b8edec3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8edec3",
  null
  
)

export default component.exports